export const FAQ_ITEMS = [
  {
    q: "Combien coûte AVELIS ?",
    a: "Le tarif correspond à 4 % TVAC des honoraires effectivement encaissés issus des facturations traitées par AVELIS, auxquels s'ajoutent les frais de logiciel.",
  },
  {
    q: "AVELIS s'occupe-t-il des rejets ?",
    a: "Oui. Les rejets administratifs liés aux facturations confiées à AVELIS sont identifiés, suivis et corrigés lorsque les informations nécessaires sont disponibles.",
  },
  {
    q: "Dois-je changer ma manière de travailler ?",
    a: "Pas nécessairement. Le premier échange permet d'identifier la méthode de transmission la plus simple selon votre organisation et vos outils.",
  },
  {
    q: "Puis-je suivre ma facturation ?",
    a: "Oui. AVELIS vous communique une synthèse claire des éléments transmis, acceptés, corrigés ou encore en attente.",
  },
];

export const SERVICE_STEPS = [
  "Réception et contrôle des prestations",
  "Encodage et tarification",
  "Transmission aux organismes assureurs",
  "Suivi et correction des rejets",
  "Synthèse claire de la facturation",
];

export const HOW_STEPS = [
  {
    n: "01",
    title: "Prenons contact",
    text: "Appelez AVELIS ou envoyez-nous un message afin de nous présenter votre activité et votre organisation.",
  },
  {
    n: "02",
    title: "Organisons la transmission",
    text: "Nous définissons ensemble les informations et les modalités nécessaires.",
  },
  {
    n: "03",
    title: "Confiez-nous votre tarification",
    text: "AVELIS prend en charge le processus convenu et vous tient informé de son suivi.",
  },
];

export const ARTICLES = [
  {
    slug: "comment-fonctionne-tarification-infirmiere-belgique",
    category: "Tarification infirmière",
    title: "Comment fonctionne la tarification infirmière en Belgique ?",
    excerpt:
      "Nomenclature, forfaits, tiers payant, transmission électronique : les mécanismes de base de la tarification infirmière expliqués simplement.",
    date: "Juillet 2026",
    datePublished: "2026-07-01",
    readTime: "5 min",
    intro:
      "La tarification infirmière belge repose sur un ensemble de règles précises : une nomenclature nationale, des prescriptions obligatoires, une transmission électronique aux mutuelles. Comprendre ce circuit — sans entrer dans le détail réglementaire — aide chaque infirmier indépendant à mieux organiser sa facturation.",
    sections: [
      {
        h2: "La nomenclature des soins infirmiers",
        paras: [
          "Chaque prestation de soins correspond à un code de la nomenclature de l'INAMI. Le code applicable dépend de la situation du patient, de la prescription médicale et des règles de cumul entre prestations. Certaines situations donnent droit à des forfaits, d'autres à des prestations facturées à l'acte.",
          "Choisir le bon code est essentiel : un code inadapté peut entraîner un rejet, un remboursement incorrect ou, à terme, un contrôle. C'est l'une des raisons pour lesquelles la tarification demande une vigilance constante.",
        ],
      },
      {
        h2: "Le tiers payant et la transmission électronique",
        paras: [
          "Dans le cadre du tiers payant, l'infirmier envoie sa facturation directement à la mutuelle du patient, qui rembourse la part de l'assurance. Le patient ne règle alors que son ticket modérateur. Cette transmission s'effectue par voie électronique, via les canaux sécurisés prévus à cet effet (MyCareNet).",
          "Chaque envoi fait l'objet d'un accusé de réception, puis d'une réponse de la mutuelle : acceptation ou rejet motivé. Ces retours doivent être lus et traités un par un.",
        ],
      },
      {
        h2: "Les retours : accusés, acceptations et rejets",
        paras: [
          "Après la transmission, la mutuelle peut accepter la facturation, la rejeter en motivant son refus, ou demander un complément. Un rejet n'est pas une fin en soi : il signale une anomalie qui doit être identifiée, corrigée lorsque c'est possible, puis retransmise.",
          "Sans suivi structuré, ces retours s'accumulent et une partie des honoraires reste simplement non encaissée.",
        ],
      },
      {
        h2: "Ce que cela implique au quotidien",
        paras: [
          "Une tarification saine repose sur trois habitudes : des documents complets avant tout encodage, une transmission régulière plutôt que concentrée en fin de mois, et un suivi rigoureux des retours. C'est précisément ce circuit qu'un office de tarification infirmière comme AVELIS organise et suit pour vous.",
        ],
      },
    ],
    conclusion:
      "Une question sur votre tarification ? Appelez AVELIS ou envoyez-nous un message WhatsApp — et estimez vos honoraires avec notre simulateur.",
    related: ["eviter-rejets-facturation-infirmiere", "informations-transmettre-office-tarification"],
  },
  {
    slug: "eviter-rejets-facturation-infirmiere",
    category: "Facturation",
    title: "Comment éviter les rejets de facturation infirmière ?",
    excerpt:
      "Un rejet signale presque toujours une anomalie identifiable et corrigeable. Les causes fréquentes, et la méthode pour les traiter durablement.",
    date: "Juillet 2026",
    datePublished: "2026-07-01",
    readTime: "4 min",
    intro:
      "Les rejets de facturation font partie du quotidien de nombreux infirmiers indépendants. Pourtant, la plupart proviennent d'un nombre limité de causes — qu'un peu de méthode permet de réduire fortement.",
    sections: [
      {
        h2: "Les causes fréquentes de rejet",
        paras: [
          "Dans la pratique, les rejets proviennent le plus souvent d'informations administratives incomplètes ou erronées, d'une prescription absente, expirée ou incohérente avec les prestations déclarées, d'une règle de cumul non respectée, ou d'un délai de transmission dépassé.",
          "Chaque motif de rejet communiqué par la mutuelle mérite d'être lu attentivement : il indique précisément ce qui doit être corrigé.",
        ],
      },
      {
        h2: "Mettre en place un contrôle avant envoi",
        paras: [
          "La majorité des rejets peut être évitée par une vérification systématique avant transmission : identité et affiliation du patient, prescription en cours de validité, cohérence entre les prestations réalisées et les codes utilisés, complétude des justificatifs.",
          "Ce contrôle prend du temps lorsqu'il est fait le soir, après les tournées. Intégré à un processus régulier, il devient beaucoup plus court — et bien plus efficace.",
        ],
      },
      {
        h2: "Suivre chaque rejet jusqu'à sa résolution",
        paras: [
          "Lorsqu'un rejet survient malgré tout, l'essentiel est de le suivre : noter le motif, appliquer la correction possible, retransmettre, et vérifier l'acceptation finale. Un rejet oublié, c'est un honoraire non encaissé.",
          "Chez AVELIS, le suivi des rejets fait partie intégrante de la prise en charge : chaque anomalie est identifiée, corrigée dans le périmètre convenu et retransmise lorsque nécessaire.",
        ],
      },
    ],
    conclusion:
      "Envie de déléguer ce suivi à un interlocuteur spécialisé ? Appelez AVELIS ou envoyez-nous un message WhatsApp.",
    related: ["comment-fonctionne-tarification-infirmiere-belgique", "informations-transmettre-office-tarification"],
  },
  {
    slug: "informations-transmettre-office-tarification",
    category: "Organisation",
    title: "Quelles informations transmettre à son office de tarification ?",
    excerpt:
      "La qualité d'une facturation dépend d'abord de la qualité des informations transmises. La liste de ce qu'il faut réunir, et comment l'organiser.",
    date: "Juillet 2026",
    datePublished: "2026-07-01",
    readTime: "4 min",
    intro:
      "Confier sa tarification à un office spécialisé ne supprime pas la transmission des informations : elle la rend plus simple et plus régulière. Voici ce qui doit être réuni pour une facturation complète et sans retard.",
    sections: [
      {
        h2: "Les informations administratives",
        paras: [
          "Pour chaque patient : identité complète, affiliation mutualiste à jour, adresse, et le cas échéant les coordonnées du médecin prescripteur. Une information administrative erronée est l'une des premières causes de rejet.",
          "Ces données doivent être transmises dans le respect du RGPD, via un canal convenu et sécurisé — jamais par des moyens informels.",
        ],
      },
      {
        h2: "Les documents de soins",
        paras: [
          "La prescription médicale en cours de validité est la pièce centrale : sans elle, pas de facturation conforme. S'y ajoutent, selon les situations, les éléments du dossier infirmier qui justifient les prestations réalisées.",
          "Vérifier la présence et la validité de ces documents avant transmission évite la plupart des allers-retours.",
        ],
      },
      {
        h2: "Les prestations réalisées",
        paras: [
          "Dates, types d'actes et fréquence : les prestations doivent être transmises de manière complète et exacte, telles qu'elles ont réellement été effectuées. L'exactitude des prestations déclarées reste toujours de la responsabilité de l'infirmier.",
        ],
      },
      {
        h2: "Organiser une transmission régulière",
        paras: [
          "Plutôt qu'un envoi massif en fin de mois, un rythme hebdomadaire ou bimensuel fluidifie les encaissements et réduit la charge. Lors de la mise en place avec AVELIS, les modalités de transmission sont définies ensemble pour s'adapter à votre organisation existante.",
        ],
      },
    ],
    conclusion:
      "Une question sur la transmission de vos informations ? Appelez AVELIS ou écrivez-nous sur WhatsApp.",
    related: ["eviter-rejets-facturation-infirmiere", "comment-fonctionne-tarification-infirmiere-belgique"],
  },
  {
    slug: "combien-coute-service-tarification-infirmiere",
    category: "Tarification infirmière",
    title: "Combien coûte un service de tarification infirmière ?",
    excerpt:
      "Forfait mensuel, pourcentage des honoraires ou prix par envoi : les modèles de prix des offices de tarification, et ce qu'il faut vraiment comparer.",
    date: "Juillet 2026",
    datePublished: "2026-07-01",
    readTime: "4 min",
    intro:
      "Il n'existe pas de prix unique pour un service de tarification infirmière : les offices de tarification appliquent des modèles différents. Comprendre ces modèles permet de comparer à périmètre égal — et d'éviter les mauvaises surprises.",
    sections: [
      {
        h2: "Les modèles de tarification courants",
        paras: [
          "Trois modèles coexistent généralement. Le forfait mensuel fixe : un montant identique chaque mois, quel que soit le volume traité. Le pourcentage des honoraires encaissés : le coût suit l'activité réelle. Et le prix par prestation ou par envoi : facturé à l'unité.",
          "Chaque modèle a ses points de vigilance. Un forfait peut devenir disproportionné lorsque l'activité baisse. Un pourcentage doit être calculé sur une assiette clairement définie. Un prix à l'unité peut masquer des coûts additionnels pour les corrections ou les retransmissions.",
        ],
      },
      {
        h2: "Ce qu'il faut comparer au-delà du prix",
        paras: [
          "Le tarif affiché ne dit rien du périmètre réel : les rejets sont-ils suivis ? Les corrections administratives sont-elles incluses ? Disposez-vous d'un relevé clair de ce qui a été transmis, accepté ou est encore en attente ? Avez-vous un interlocuteur identifié ?",
          "Un service légèrement moins cher mais sans suivi des rejets peut coûter davantage en honoraires non encaissés.",
        ],
      },
      {
        h2: "Le modèle choisi par AVELIS",
        paras: [
          "AVELIS a fait le choix d'un tarif unique et lisible : 4 % TVAC des honoraires effectivement encaissés issus des facturations traitées par AVELIS, auxquels s'ajoutent les frais de logiciel. Vous ne payez que sur ce qui est réellement encaissé, sans abonnement ni formule complexe.",
          "Concrètement : pour 10 000 € d'honoraires encaissés via les facturations traitées, les honoraires AVELIS s'élèvent à 400 € TVAC, auxquels s'ajoutent les frais de logiciel. Vous pouvez estimer votre propre situation avec notre simulateur.",
        ],
      },
    ],
    conclusion:
      "Estimez vos frais en quelques secondes avec le simulateur, puis appelez-nous ou écrivez-nous sur WhatsApp si vous souhaitez en parler.",
    related: ["comment-fonctionne-tarification-infirmiere-belgique", "eviter-rejets-facturation-infirmiere"],
  },
];

export const CATEGORIES = ["Tous", "Tarification infirmière", "Facturation", "Organisation"];
